import React from 'react';
import Skeleton from './Skeleton';

/**
 * ResidenceFormSkeleton
 * Shimmer placeholder for the Create/Edit Residence (client profile edit) form:
 *   - back button + title/subtitle
 *   - form card with photo field, then labelled input rows and actions
 * Built from the base <Skeleton /> block (pure Tailwind shimmer).
 */

const S = Skeleton;

const FieldSkeleton = ({ input = 'h-11' }) => (
  <div>
    <S className="h-3.5 w-32 rounded-md mb-2" />
    <S className={`${input} w-full rounded-lg`} />
  </div>
);

const ResidenceFormSkeleton = () => (
  <div className="max-w-2xl mx-auto">
    {/* Header */}
    <div className="flex items-center gap-4 mb-6">
      <S className="w-10 h-10 rounded-lg shrink-0" />
      <div className="flex-1 space-y-2">
        <S className="h-7 w-56 rounded-xl" />
        <S className="h-3.5 w-64 max-w-full rounded-md" />
      </div>
    </div>

    {/* Form card */}
    <div className="bg-white dark:bg-[#262b33] rounded-[20px] border border-[#E3E9F3] dark:border-gray-800 shadow-[0_1px_2px_rgba(15,23,42,0.05),0_4px_10px_-3px_rgba(15,23,42,0.06)] p-6">
      {/* Photo field */}
      <S className="h-3.5 w-28 rounded-md mb-3" />
      <div className="flex gap-2 mb-4">
        <S className="h-7 w-24 rounded" />
        <S className="h-7 w-24 rounded" />
      </div>
      <S className="h-28 w-full rounded-lg mb-6" />

      {/* Input rows */}
      <div className="space-y-6">
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton />
        <FieldSkeleton input="h-24" />
      </div>

      {/* Actions */}
      <div className="flex gap-3 pt-6 mt-6 border-t border-[#EEF2F8] dark:border-gray-800">
        <S className="h-11 flex-1 rounded-xl" />
        <S className="h-11 flex-1 rounded-xl" />
      </div>
    </div>
  </div>
);

export default ResidenceFormSkeleton;
